import axios from 'axios'
import constant from '../config/constant'
import store from '../store/index'

let token = store.getters['Auth/token']
let currentBranchId = store.getters['Auth/currentBranchId']


axios.defaults.headers.common['Authorization'] = token
axios.defaults.headers.common['BranchID'] = currentBranchId

const instance = axios.create({
  baseURL: constant.webBaseURL,
  headers: {
    'Content-Type': 'application/json',
    //'Authorization': token,
    //'BranchID': currentBranchId
  }
})

// axios 1.x, yukarıdaki 'application/json' başlığı varken FormData gövdesini JSON'a çevirir;
// 0.19 FormData'da Content-Type'ı silerdi. Yüklemelerde başlık silinir, tarayıcı
// multipart/form-data'yı boundary ile kendisi koyar.
instance.interceptors.request.use(config => {
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    config.headers.delete('Content-Type')
  }
  return config
})

export default instance
